export default "__VITE_ASSET__82fca5e1__"